var _a;
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { ProductLogo } from './ProductLogo';
export var DialogWidth;
(function (DialogWidth) {
    DialogWidth[DialogWidth["Small"] = 0] = "Small";
    DialogWidth[DialogWidth["Medium"] = 1] = "Medium";
    DialogWidth[DialogWidth["Large"] = 2] = "Large";
})(DialogWidth || (DialogWidth = {}));
var widths = (_a = {},
    _a[DialogWidth.Small] = '20rem',
    _a[DialogWidth.Medium] = '30rem',
    _a[DialogWidth.Large] = '40rem',
    _a);
export var Dialog = function (_a) {
    var className = _a.className, header = _a.header, children = _a.children, footer = _a.footer, _b = _a.width, width = _b === void 0 ? DialogWidth.Medium : _b;
    return (jsx("div", null,
        jsx("div", { sx: {
                p: 2,
                bg: 'light',
                left: 0,
                top: 0,
                right: 0,
                height: 400,
                borderColor: 'grey',
                borderWidth: 1,
                borderBottomStyle: 'solid',
            } },
            jsx("div", { sx: { textAlign: 'center', mt: 4 } },
                jsx(ProductLogo, null)),
            jsx("div", { className: className, sx: {
                    width: ['100%', widths[width]],
                    mx: [0, 'auto'],
                    backgroundColor: 'white',
                    p: 4,
                    borderStyle: 'solid',
                    borderWidth: 1,
                    borderColor: 'grey',
                    mt: 5,
                    mb: 4,
                    borderRadius: function (theme) { return theme.borderRadius; },
                    boxShadow: function (theme) { return theme.boxShadow; },
                } },
                header && (jsx("div", { sx: {
                        fontSize: 4,
                        fontWeight: 'bold',
                        color: 'dark',
                        mb: 3,
                    } }, header)),
                children,
                footer && (jsx("div", { sx: {
                        mt: 4,
                        display: 'flex',
                        flexDirection: ['column-reverse', 'row'],
                        justifyContent: ['flex-start', 'space-between'],
                        alignItems: ['stretch', 'center'],
                    } }, footer))))));
};
//# sourceMappingURL=Dialog.js.map